import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Suppress cross-origin script errors from third-party embeds (Instagram, Facebook)
// These are benign errors that don't affect functionality
window.addEventListener('error', (event) => {
  if (event.message === 'Script error.' && !event.filename) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
